export default __webpack_public_path__ + "static/media/icon_clap_white.918d6445.svg";